export const trackGoal = (id, value = 0) => {
  if (!window?.fathom) return
  window.fathom.trackGoal(id, value)
}
